import { BonusHandlingEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/bonus-handling.enum';
import {
  BusinessPartnerEditMode,
  BusinessPartnerInactivationMode,
} from '@albatrosdeveloper/ave-models-package/lib/enums/business-partner-inactivation-mode.enum';
import { DepartmentAreaEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/department-area.enum';
import { QuestionTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/question-type.enum';
import { SurveyAssignmentScopeTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/survey-assignment-scope-type.enum';
import { UserFieldEntityTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum';
import { MaterialFilterSourceEnum, MaterialStandardFilterEnum } from '@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/material-filter.enum';

export const BONUS_HANDLING_OPTIONS = [
  { label: 'Línea gratuita separada', value: BonusHandlingEnum.SEPARATE_FREE_LINE },
  {
    label: 'Incluida en posición con recálculo de precio',
    value: BonusHandlingEnum.INCLUDED_WITH_PRICE_RECALCULATION,
  },
  {
    label: 'Incluida en posición sin recálculo de precio',
    value: BonusHandlingEnum.INCLUDED_WITHOUT_PRICE_RECALCULATION,
  },
  {
    label: 'Bonificación incluida en posición con descuento',
    value: BonusHandlingEnum.INCLUDED_AS_DISCOUNT,
  },
];

export const USER_FIELD_ENTITY_LIST = [
  { label: 'Socio de Negocios', value: UserFieldEntityTypeEnum.BUSINESS_PARTNER },
  {
    label: 'Cadena de Distribución de socio de negocios',
    value: UserFieldEntityTypeEnum.BP_DISTRIBUTION_CHAIN,
  },
  { label: 'Material', value: UserFieldEntityTypeEnum.MATERIAL },
  {
    label: 'Cadena de Distribución de materiales',
    value: UserFieldEntityTypeEnum.MATERIAL_DISTRIBUTION_CHAIN,
  },
  { label: 'Clase de documento', value: UserFieldEntityTypeEnum.DOCUMENT_CLASS },
  { label: 'Ruta', value: UserFieldEntityTypeEnum.SUB_ROUTE },
];

export const DEPARTMENT_AREA_OPTIONS = [
  { label: 'Almacén', value: DepartmentAreaEnum.WAREHOUSE },
  { label: 'Compras', value: DepartmentAreaEnum.PURCHASING },
  { label: 'Finanzas', value: DepartmentAreaEnum.FINANCE },
  { label: 'Logística', value: DepartmentAreaEnum.LOGISTICS },
  { label: 'Comercial', value: DepartmentAreaEnum.COMMERCIAL },
  { label: 'Ventas', value: DepartmentAreaEnum.SALES },
  { label: 'Auditoría', value: DepartmentAreaEnum.AUDIT },
  { label: 'Créditos', value: DepartmentAreaEnum.CREDITS },
  { label: 'Otros', value: DepartmentAreaEnum.OTHERS },
];

export const statusChanges = [
  { value: 1, label: 'Activo' },
  { value: 0, label: 'Anulado' },
  { value: 6, label: 'En progreso' },
  { value: 7, label: 'Aprobado' },
  { value: 14, label: 'Aprobado Parcialmente' },
  { value: 8, label: 'Rechazado' },
  { value: 18, label: 'Inactivo por falta de inventario' },
  { value: 9, label: 'Entregado completamente al cliente' },
  { value: 10, label: 'Entregado parcialmente al cliente' },
  { value: 11, label: 'Entrega rechazada por el cliente' },
  { value: 17, label: 'Orden finalizada' },
];

export const fieldTypeOptionsForm = [
  { value: 'text', label: 'Texto' },
  { value: 'number', label: 'Número' },
  { value: 'email', label: 'Email' },
  { value: 'date', label: 'Fecha' },
  { value: 'boolean', label: 'Booleano' },
  { value: 'select', label: 'Select' },
  { value: 'multiselect', label: 'Multiselect' },
  { value: 'form', label: 'Formulario' },
  { value: 'attachment', label: 'Adjunto' },
];

export const fieldTypeOptionsWithouForm = [
  { value: 'text', label: 'Texto' },
  { value: 'number', label: 'Número' },
  { value: 'email', label: 'Email' },
  { value: 'date', label: 'Fecha' },
  { value: 'boolean', label: 'Booleano' },
  { value: 'select', label: 'Select' },
  { value: 'multiselect', label: 'Multiselect' },
  { value: 'attachment', label: 'Adjunto' },
];

export const userEntityLabels = [
  { label: 'Socios de Negocio', value: UserFieldEntityTypeEnum.BUSINESS_PARTNER },
  {
    label: 'Cadena de Distribución de socio',
    value: UserFieldEntityTypeEnum.BP_DISTRIBUTION_CHAIN,
  },
  { label: 'Materiales', value: UserFieldEntityTypeEnum.MATERIAL },
  {
    label: 'Cadena de Distribución de material',
    value: UserFieldEntityTypeEnum.MATERIAL_DISTRIBUTION_CHAIN,
  },
  { label: 'Clases de documento', value: UserFieldEntityTypeEnum.DOCUMENT_CLASS },
  { label: 'Rutas', value: UserFieldEntityTypeEnum.SUB_ROUTE },
];

export const businessPartnerInactivationMode = [
  {
    label: 'Se desactiva automáticamente a la ultima aprobación la solicitud',
    value: BusinessPartnerInactivationMode.AUTO_ON_APPROVAL,
  },
  {
    label: 'Se desactiva inmediatamente al crear la solicitud',
    value: BusinessPartnerInactivationMode.IMMEDIATE_ON_REQUEST,
  }
];

export const businessPartnerInactivationModeWithERP = [
  {
    label: 'Se desactiva automáticamente a la ultima aprobación la solicitud',
    value: BusinessPartnerInactivationMode.AUTO_ON_APPROVAL,
  },
  {
    label: 'Se desactiva inmediatamente al crear la solicitud',
    value: BusinessPartnerInactivationMode.IMMEDIATE_ON_REQUEST,
  },
  {
    label: 'Al completar aprobaciones, se envía sincronización al ERP y luego se inactiva',
    value: BusinessPartnerInactivationMode.POST_ERP_SYNC,
  },
  {
    label: 'Se aprueba, pero la inactivación la hace el ERP',
    value: BusinessPartnerInactivationMode.MANUAL_ERP_SYNC,
  },
];

export const businessPartnerEditMode = [
  {
    label: 'Se aplican los cambios automáticamente al aprobar la solicitud',
    value: BusinessPartnerEditMode.AUTO_ON_APPROVAL,
  },
];

export const businessPartnerEditModeWithERP = [
  {
    label: 'Se aplican los cambios automáticamente al aprobar la solicitud',
    value: BusinessPartnerEditMode.AUTO_ON_APPROVAL,
  },
  {
    label: 'Al completar aprobaciones, se sincroniza con el ERP y luego se aplican los cambios',
    value: BusinessPartnerEditMode.WITH_ERP_SYNC,
  },
];

export const questionTypeOptions = [
  { label: 'Selección Única', value: QuestionTypeEnum.SINGLE_CHOICE },
  { label: 'Selección Múltiple', value: QuestionTypeEnum.MULTIPLE_CHOICE },
  { label: 'Pregunta Abierta', value: QuestionTypeEnum.OPEN_ENDED },
  { label: 'Escala de Calificación', value: QuestionTypeEnum.RATING_SCALE },
  { label: 'Escala Likert', value: QuestionTypeEnum.LIKERT },
  { label: 'Entrada Numérica', value: QuestionTypeEnum.NUMERIC_INPUT },
  { label: 'Selector de Fecha', value: QuestionTypeEnum.DATE_PICKER },
  { label: 'Lista Desplegable', value: QuestionTypeEnum.DROPDOWN },
  { label: 'Matriz de Opciones', value: QuestionTypeEnum.MATRIX },
  { label: 'Ranking / Priorización', value: QuestionTypeEnum.RANKING },
  { label: 'Sí / No', value: QuestionTypeEnum.YES_NO },
  { label: 'Selección de Imagen', value: QuestionTypeEnum.IMAGE_CHOICE },
  { label: 'Deslizador (Slider)', value: QuestionTypeEnum.SLIDER },
  { label: 'NPS (Net Promoter Score)', value: QuestionTypeEnum.NPS },
  { label: 'Ranking (Arrastrar y Soltar)', value: QuestionTypeEnum.RANKING_DRAG_DROP },
  { label: 'Selector de Hora', value: QuestionTypeEnum.TIME_PICKER },
  { label: 'Firma Digital', value: QuestionTypeEnum.SIGNATURE },
  { label: 'Multimedia (Video)', value: QuestionTypeEnum.MULTIMEDIA_VIDEO },
  { label: 'Multimedia (Audio)', value: QuestionTypeEnum.MULTIMEDIA_AUDIO },
  { label: 'Consentimiento / Términos', value: QuestionTypeEnum.CONSENT },
  { label: 'Matriz de Selección Múltiple', value: QuestionTypeEnum.MULTI_MATRIX },
  { label: 'Matriz Anidada', value: QuestionTypeEnum.MATRIX_NESTED },
  { label: 'Desplegable de Selección Múltiple', value: QuestionTypeEnum.MULTI_DROPDOWN },
  { label: 'Selector de Duración', value: QuestionTypeEnum.DURATION_PICKER },
];

export const surveyAssignmentScopeOptions = [
  { label: 'Ruta', value: SurveyAssignmentScopeTypeEnum.ROUTE },
  { label: 'Territorio', value: SurveyAssignmentScopeTypeEnum.TERRITORY },
  { label: 'Departamento', value: SurveyAssignmentScopeTypeEnum.DEPARTMENT },
  { label: 'Ciudad', value: SurveyAssignmentScopeTypeEnum.CITY },
  { label: 'Grupo de Clientes', value: SurveyAssignmentScopeTypeEnum.CUSTOMER_GROUP },
  { label: 'Oficina de Ventas', value: SurveyAssignmentScopeTypeEnum.SALES_OFFICE },
];

export const MATERIAL_FILTER_SOURCE_OPTIONS = [
  { label: 'Estándar', value: MaterialFilterSourceEnum.STANDARD },
  { label: 'UDF (Campo de usuario)', value: MaterialFilterSourceEnum.UDF },
];

export const MATERIAL_STANDARD_FILTER_OPTIONS = [
  { label: 'MARCA', value: MaterialStandardFilterEnum.BRAND },
  { label: 'PRESENTACIÓN', value: MaterialStandardFilterEnum.PRESENTATION },
  { label: 'GRUPO', value: MaterialStandardFilterEnum.GROUP },
  { label: 'JERARQUÍA DE VENTAS', value: MaterialStandardFilterEnum.SALES_HIERARCHY },
  { label: 'UNIDAD DE MEDIDA', value: MaterialStandardFilterEnum.UNIT_OF_MEASUREMENT },
  { label: 'CATEGORÍA', value: MaterialStandardFilterEnum.CATEGORY },
];

export const ICON_OPTIONS = [
  // Navigation & General
  'person', 'group', 'home', 'settings', 'folder', 'star', 'email', 'phone',
  'info', 'warning', 'check_circle', 'build', 'description', 'shopping_cart',
  'attach_money', 'map', 'schedule', 'list', 'store', 'local_shipping',
  // Actions & Status
  'add', 'edit', 'delete', 'search', 'close', 'check', 'help', 'refresh',
  'lock', 'lock_open', 'visibility', 'visibility_off', 'cloud', 'cloud_upload',
  // Documents & Business
  'assignment', 'receipt', 'insert_drive_file', 'business', 'work', 'assessment',
  'pie_chart', 'trending_up', 'payment', 'credit_card', 'account_balance',
  // Places & Logistics
  'place', 'navigation', 'my_location', 'pin_drop', 'room', 'category',
  'label', 'bookmark', 'favorite', 'thumb_up', 'thumb_down', 'share',
  // Communication & People
  'chat', 'comment', 'contact_support', 'contacts', 'feedback', 'notifications',
  // Utilities
  'computer', 'smartphone', 'event', 'calendar_today', 'alarm', 'sync',
  'wifi', 'bluetooth', 'battery_charging_full', 'extension'
];

export const ICON_COLOR_OPTIONS: { name: string; value: string }[] = [
  { name: 'blue', value: '#0000FF' },
  { name: 'red', value: '#FF0000' },
  { name: 'green', value: '#008000' },
  { name: 'orange', value: '#FFA500' },
  { name: 'purple', value: '#800080' },
  { name: 'pink', value: '#FFC0CB' },
  { name: 'yellow', value: '#FFFF00' },
  { name: 'indigo', value: '#4B0082' },
  { name: 'gray', value: '#808080' },
  { name: 'teal', value: '#008080' },
];
